export default {
  title: 'Máte nemovitost k zástavě?',
  tooltip: 'Víte, že nemovitost nemusí být přímo ve vašem vlastnictví? Může to být třetí osoba - někdo z rodiny nebo jakákoliv osoba, která poskytne souhlas.',
  haveRealty: {
    yes: 'Mám',
    no: 'Nemám',
  },
  address: {
    label: 'Vyhledejte a vyberte adresu nemovitosti',
    errorMessages: {
      required: 'Adresa nemovitosti musí být vybrána.',
      choosed: 'Adresa nemovitosti musí být vybrána ze seznamu adres.',
    },
  },
  button: 'Přejít na další krok',
  thankYou: 'Nyní od Vás máme vše co jsme potřebovali. Pokud chcete žádost urychlit pokračujte dále s krokem 4 zajištění a krokem 5. dokumenty.',
  cover: 'Zajištěni',
};
